<template>
  <el-dialog :title="$t('staffSnapshot.addTitle')" :visible.sync="visible" width="900px" @close="resetForm">
    <el-form :model="form" :rules="rules" ref="form" label-width="100px">
      <el-form-item :label="$t('staffSnapshot.staffName')">
        <el-input v-model.trim="currentStaffName" disabled />
      </el-form-item>
      <el-form-item :label="$t('staffSnapshot.photo')" prop="photoUrl">
        <upload-image-url ref="uploadImage" :image-count="20" @notifyUploadCoverImage="handleUploadImage" />
      </el-form-item>
      <el-form-item :label="$t('staffSnapshot.category')" prop="category">
        <el-input v-model.trim="form.category" disabled />
      </el-form-item>
      <el-form-item :label="$t('staffSnapshot.address')" prop="address">
        <el-input v-model.trim="form.address" />
      </el-form-item>
      <el-form-item :label="$t('staffSnapshot.description')" prop="description">
        <el-input v-model.trim="form.description" type="textarea" />
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="visible = false">{{ $t('common.cancel') }}</el-button>
      <el-button type="primary" @click="handleSubmit">{{ $t('common.save') }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { saveStaffSnapshot } from '@/api/staff/staffSnapshotApi'
import { getUserName } from '@/api/user/userApi'
import UploadImageUrl from '@/components/upload/UploadImageUrl.vue'

export default {
  name: 'AddStaffSnapshot',
  components: { UploadImageUrl },
  data() {
    return {
      visible: false,
      currentStaffName: '',
      form: {
        photoUrl: '',
        category: '',
        address: '',
        description: ''
      },
      rules: {
        photoUrl: [
          { required: true, message: this.$t('common.pleaseUpload'), trigger: 'change' }
        ]
      }
    }
  },
  methods: {
    open() {
      this.currentStaffName = getUserName() || ''
      this.visible = true
    },
    resetForm() {
      this.form = {
        photoUrl: '',
        category: '',
        address: '',
        description: ''
      }
      this.$refs.form && this.$refs.form.resetFields()
    },
    handleUploadImage(urls) {
      if (urls && urls.length > 0) {
        this.form.photoUrl = urls.join(',')
      } else {
        this.form.photoUrl = ''
      }
    },
    handleSubmit() {
      this.$refs.form.validate(async (valid) => {
        if (!valid) return
        const res = await saveStaffSnapshot({
          photoUrl: this.form.photoUrl,
          category: this.form.category,
          address: this.form.address,
          description: this.form.description
        })
        if (res.code === 0) {
          this.$message.success(this.$t('common.operationSuccess'))
          this.visible = false
          this.$emit('success')
        } else {
          this.$message.error(res.msg || this.$t('common.operationFailed'))
        }
      })
    }
  }
}
</script>
